import {
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
    GET_MEDIA_DASHBOARD_DATA_TABLE_PAGINATION_STATE,
    SET_SPACE_ASSET_CONTENT_TYPE,
    SET_MEDIA_DASHBOARD_STATE,
    SET_MEDIA_DASHBOARD_DATA_TABLE_PAGINATION_STATE,
    SET_CREATE_ASSET_STATE,
    SET_CREATE_ASSET_PROGRESS,
    SET_ARCHIVE_ASSET_STATE,
    SET_TRIM_ASSET_STATE,
    SET_MEDIA_DASHBOARD_STATE_AND_RELOAD,
    GET_FILTERED_MEDIA_ENTRIES,
    LOAD_SPACE_ASSET_CONTENT_TYPE,
    LOAD_SPACE_CONTENT_ARCHIVED,
    LOAD_SPACE_CONTENT,
    A_TRIM_ASSET,
    A_ARCHIVE_ASSET,
    A_CREATE_ASSET,
    ARCHIVED_TEXT, SET_STITCH_ASSETS_STATE, A_STITCH_ASSETS,
} from "../services/constants"
import lodash from "../services/lodash"
import http from "../services/axios"
import helpers from '../services/helpers'
import {asyncObjectConstructor} from "../services/helpers"

export const mediaStoreModule = {
    state: {
        spaceAssetContentType: null,
        mediaDashboardState: {
            selectedMediaType: {
                category: 'All',
                displayName: 'All',
            },
            showArchived: false,
            paginationSync: {
                sortBy: 'name',
                descending: false,
                rowsPerPage: 25,
                // rowsPerPage: Number.MAX_SAFE_INTEGER,
            },
            searchFilterTerm: '',
        },
        assetsContentType: 'asset',
        allMediaType: {
            category: 'All',
            displayName: 'All',
        },
        mediaTypes: [
            {
                mimeType: 'image/bmp',
                category: 'Image',
                displayName: 'bitmap',
            },
            {
                mimeType: 'image/gif',
                category: 'Image',
                displayName: 'gif',
            },
            {
                mimeType: 'image/jpeg',
                category: 'Image',
                displayName: 'jpg',
            },
            {
                mimeType: 'image/tiff',
                category: 'Image',
                displayName: 'tif',
            },
            {
                mimeType: 'image/webp',
                category: 'Image',
                displayName: 'webp',
            },
            {
                mimeType: 'image/png',
                category: 'Image',
                displayName: 'png',
            },
            {
                mimeType: 'image/svg+xml',
                category: 'Image',
                displayName: 'svg',
            },
            {
                mimeType: 'application/pdf',
                category: 'PDF',
                displayName: 'pdf',
            },
            {
                mimeType: 'audio/mp3',
                category: 'Audio',
                displayName: 'mp3',
            },
            {
                mimeType: 'audio/mpeg',
                category: 'Audio',
                displayName: 'mp3',
            },
            {
                mimeType: 'audio/m4a',
                category: 'Audio',
                displayName: 'm4a',
            },
            {
                mimeType: 'audio/x-m4a',
                category: 'Audio',
                displayName: 'm4a',
            },
            {
                mimeType: 'audio/mp4',
                category: 'Audio',
                displayName: 'm4a',
            },
            {
                mimeType: 'audio/wav',
                category: 'Audio',
                displayName: 'wav',
            },
            {
                mimeType: 'audio/x-wav',
                category: 'Audio',
                displayName: 'wav',
            },
            {
                mimeType: 'video/mp4',
                category: 'Video',
                displayName: 'mp4',
            },
            {
                mimeType: 'video/mpeg',
                category: 'Video',
                displayName: 'mpeg',
            },
        ],
        trimAssetState: helpers.asyncArrayConstructor(),
        archiveAssetState: asyncObjectConstructor(),
        createAssetState: asyncObjectConstructor(),
        createAssetProgress: 0,
        stitchAssetsState: asyncObjectConstructor(),
    },
    getters: {
        [GET_MEDIA_DASHBOARD_DATA_TABLE_PAGINATION_STATE]: (state) => {
            return lodash.cloneDeep(state.mediaDashboardState.paginationSync)
        },
        [GET_FILTERED_MEDIA_ENTRIES]: (state, getters, rootState) => {
            const entries = state.mediaDashboardState.showArchived ?
                rootState.archive.spaceContent[state.assetsContentType]
                : rootState.spaceContent[state.assetsContentType]
            if (entries) {
                const searchFiltered = helpers.searchEntries(entries, state.mediaDashboardState.searchFilterTerm)
                if (state.mediaDashboardState.selectedMediaType && state.mediaDashboardState.selectedMediaType.category !== state.allMediaType.category) {
                    return searchFiltered.filter(entry => {
                        return helpers.getMediaTypeOfEntry(entry, rootState).category === state.mediaDashboardState.selectedMediaType.category
                    })
                }
                return searchFiltered
            }
            return []
        }
    },
    mutations: {
        [SET_SPACE_ASSET_CONTENT_TYPE]: (state, payload) => {
            state.spaceAssetContentType = payload
        },
        [SET_MEDIA_DASHBOARD_STATE]: (state, payload) => {
            state.mediaDashboardState = lodash.merge(state.mediaDashboardState, payload)
        },
        [SET_MEDIA_DASHBOARD_DATA_TABLE_PAGINATION_STATE]: (state, payload) => {
            state.mediaDashboardState.paginationSync = lodash.cloneDeep(payload)
        },
        [SET_TRIM_ASSET_STATE]: (state, payload) => {
            state.trimAssetState = payload
        },
        [SET_ARCHIVE_ASSET_STATE]: (state, payload) => {
            state.archiveAssetState = payload
        },
        [SET_CREATE_ASSET_STATE]: (state, payload) => {
            state.createAssetState = payload
        },
        [SET_CREATE_ASSET_PROGRESS]: (state, payload) => {
            state.createAssetProgress = payload
        },
        [SET_STITCH_ASSETS_STATE]: (state, payload) => {
            state.stitchAssetsState = payload
        },
    },
    actions: {
        [LOAD_SPACE_ASSET_CONTENT_TYPE]: (context) => {
            http.get(`api/management/spaces/${context.rootState.spaceMetadata.id}/content-types/asset`).then(results => {
                context.commit(SET_SPACE_ASSET_CONTENT_TYPE, results.data);
            }).catch(err => {
                console.log(err)
            })
        },
        [SET_MEDIA_DASHBOARD_STATE_AND_RELOAD]: (context, payload) => {
            context.commit(SET_MEDIA_DASHBOARD_STATE, payload);
            const content = context.state.mediaDashboardState.showArchived ?
                context.rootState.archive.spaceContent['asset'] :
                context.rootState.spaceContent['asset']
            if (!content) {
                const action = context.state.mediaDashboardState.showArchived ?
                    LOAD_SPACE_CONTENT_ARCHIVED : LOAD_SPACE_CONTENT
                context.dispatch(action, {
                    identifier: 'asset',
                    filterRef: context.state.mediaDashboardState,
                })
            }
        },
        [A_TRIM_ASSET]: async ({commit, state, rootState}, {entry, start, duration}) => {
            // entry: Number, the id of the entry to trim
            // start: Number, the offset from the beginning of the asset in seconds
            // duration: Number, the total length of the asset starting from start, in seconds

            const newState = asyncObjectConstructor()
            newState.loadingState = LOADING_STARTED
            commit(SET_TRIM_ASSET_STATE, newState)
            const body = {
                entry,
                start,
                duration,
            }
            try {
                const results = await http.post(`api/management/spaces/${rootState.spaceMetadata.id}/assets/trim`, body)
                const newState = asyncObjectConstructor()
                newState.loadingState = LOADING_COMPLETED_SUCCESS
                newState.data = results.data
                commit(SET_TRIM_ASSET_STATE, newState)
            } catch (e) {
                const newState = asyncObjectConstructor()
                newState.loadingState = LOADING_COMPLETED_FAILURE
                newState.error = e
                commit(SET_TRIM_ASSET_STATE, newState)
            }

            return state.trimAssetState
        },
        [A_ARCHIVE_ASSET]: async ({commit, rootState}, {entry}) => {
            const shallowEntryClone = Object.assign({}, entry)
            shallowEntryClone.status = ARCHIVED_TEXT
            const newState = asyncObjectConstructor()
            newState.loadingState = LOADING_STARTED
            commit(SET_ARCHIVE_ASSET_STATE, newState)

            const formData = new FormData()
            formData.append('entry', JSON.stringify(shallowEntryClone))

            try {
                const result = await http.post(`api/management/spaces/${rootState.spaceMetadata.id}/assets/${shallowEntryClone.id}`, formData)
                const newState = asyncObjectConstructor()
                newState.loadingState = LOADING_COMPLETED_SUCCESS
                newState.data = result.data
                commit(SET_ARCHIVE_ASSET_STATE, newState)
            } catch (e) {
                const newState = asyncObjectConstructor()
                newState.loadingState = LOADING_COMPLETED_FAILURE
                newState.error = e
                commit(SET_ARCHIVE_ASSET_STATE, newState)
            }
        },
        [A_CREATE_ASSET]: async ({commit, state, rootState}, {entry, file}) => {
            const newState = asyncObjectConstructor()
            newState.loadingState = LOADING_STARTED
            commit(SET_CREATE_ASSET_STATE, newState)

            const formData = new FormData()
            formData.append('entryCreation', JSON.stringify(entry))
            formData.append('file', file)
            try {
                const result = await http.post(`api/management/spaces/${rootState.spaceMetadata.id}/assets`, formData,
                    {
                        onUploadProgress: function (progressEvent) {
                            if (progressEvent.lengthComputable) {
                                commit(SET_CREATE_ASSET_PROGRESS, Math.round((progressEvent.loaded * 100) / progressEvent.total))
                            }
                        }
                    })
                const newState = asyncObjectConstructor()
                newState.loadingState = LOADING_COMPLETED_SUCCESS
                newState.data = result.data
                commit(SET_CREATE_ASSET_STATE, newState)
            } catch (e) {
                const newState = asyncObjectConstructor()
                newState.loadingState = LOADING_COMPLETED_FAILURE
                newState.error = e
                commit(SET_CREATE_ASSET_STATE, newState)
            }
            return state.createAssetState
        },
        [A_STITCH_ASSETS]: async ({commit, state, rootState}, {entryIds}) => {
            const newState = asyncObjectConstructor()
            newState.loadingState = LOADING_STARTED
            commit(SET_STITCH_ASSETS_STATE, newState)

            const body = {
                entries: entryIds
            }
            try {
                const result = await http.post(`api/management/spaces/${rootState.spaceMetadata.id}/assets/stitch`, body)
                const newState = asyncObjectConstructor()
                newState.loadingState = LOADING_COMPLETED_SUCCESS
                newState.data = result.data
                commit(SET_STITCH_ASSETS_STATE, newState)
            } catch (e) {
                const newState = asyncObjectConstructor()
                newState.loadingState = LOADING_COMPLETED_FAILURE
                newState.error = e
                commit(SET_STITCH_ASSETS_STATE, newState)
            }
            return state.stitchAssetsState
        }
    },
}
